import '../scss/product.scss';
import { mountSlider } from '../components/product-slider';
import { $Q } from '../utils/query-selector';
import '../components/upsell-api';
import { onClickDeploy } from '../components/read-more-less';
import {
  loadSubscriptionForms,
  toggleSubscriptionInfo,
} from '../components/subscription-form';
import {
  selectFirstVariant,
  variantOnChange,
} from '../components/variants-product';
import { loadTabsEvents } from '../components/accordion-tabs';
import { onChangeItemProduct } from '../components/quantity-change';
import { onClickReviews } from '../components/reviews';

const productSwiperInstance = mountSlider(
  $Q('.swiper.main-product__slider-principal')
);

if (document.querySelectorAll('.funnel-cta-popup-opener').length > 0) {

  var popupOpener = document.querySelector('.funnel-cta-popup-opener');
  var popupContainer = document.querySelector('.funnel-cta-popup-container');
  var popupOverlay = document.querySelector('.funnel-cta-popup__overlay');
  var popupClose = document.querySelector('.funnel-cta-popup__close');

  popupOpener.addEventListener('click',function(){
    popupContainer.classList.add('active');
  })
  popupOverlay.addEventListener('click',function(){
    popupContainer.classList.remove('active');
  })
  popupClose.addEventListener('click',function(){
    popupContainer.classList.remove('active');
  })
}

variantOnChange('.variants', productSwiperInstance);

onClickDeploy($Q('.description'));

loadSubscriptionForms();
toggleSubscriptionInfo();

loadTabsEvents();
onChangeItemProduct();

onClickReviews();

selectFirstVariant();